import apollo from './apolloLogo.png'
import css from './cssLogo.png'
import figma from './figmaLogo.png'
import graphql from './graphqlLogo.png'
import html from './htmlLogo.png'
import javascript from './javascriptLogo.png'
import mongo from './mongoLogo.png'
import node from './nodeLogo.png'
import react from './reactLogo.png'
import sass from './sassLogo.png'
import typescript from './typescriptLogo.png'

const logo = {
    apollo,
    css,
    figma,
    graphql,
    html,
    javascript,
    mongo,
    node,
    react,
    sass,
    typescript
}

export default logo